import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import serialize from 'form-serialize';

import { AppContext } from '@prisjakt/ui-app-context';
import T from '@prisjakt/ui-translate';
import { TextInput, TextArea, Radio } from 'src/components/inputs';
import Button from '@prisjakt/ui-button';

import types from '../../types';
import feedbackActions from '../../actions';

import * as S from './styles';

export class FeedbackForm extends React.PureComponent {
  constructor(props) {
    super(props);

    this.sendFeedback = this.sendFeedback.bind(this);

    this.email = null;
  }

  componentDidMount() {
    if (this.email) {
      this.email.focus();
    }
  }

  sendFeedback(e) {
    e.preventDefault();

    const formData = serialize(e.target, {
      hash: true,
    });

    const message = this.createMessage(formData);

    this.props.sendRequest(message);
  }

  createMessage({ message, email, agentTypeKey }) {
    return {
      message,
      uri: window.location.toString(),
      email,
      country_code: this.context.market.code,
      additional_info: `
      %${this.props.feedback.tag}%

      ${navigator.userAgent}`,
      agent_type_key: agentTypeKey || 'other',
    };
  }

  static getTypes() {
    return Object.values(types);
  }

  render() {
    const { t } = this.context;
    const { feedback } = this.props;

    return (
      <S.Inner data-test="FeedbackForm">
        <S.Title>
          <T domain="feedback">dialog.title</T>
        </S.Title>

        <S.Description>
          <T domain="feedback">dialog.description</T>
        </S.Description>

        {Boolean(feedback.error) && (
          <S.HelperText error>
            <T domain="feedback">{feedback.error}</T>
          </S.HelperText>
        )}

        <S.Form method="post" onSubmit={this.sendFeedback}>
          {types && (
            <S.Section>
              <S.Subtitle>{t('feedback', 'dialog.subtitle')}</S.Subtitle>
              {FeedbackForm.getTypes().map(type => (
                <Radio
                  key={type.text}
                  id={type.text}
                  name="agentTypeKey"
                  value={type.key}
                  label={t('feedback', type.text)}
                  tabIndex="0"
                  defaultChecked={type.text === 'type.suggestion'}
                />
              ))}
            </S.Section>
          )}

          <S.Section>
            <TextInput
              required
              type="email"
              name="email"
              label={t('feedback', 'dialog.email-label')}
              helper={t('feedback', 'dialog.email-helper')}
              tabIndex="0"
              inputRef={el => {
                this.email = el;
              }}
            />

            <TextArea
              required
              name="message"
              label={t('feedback', 'dialog.message-label')}
              tabIndex="0"
            />

            {feedback.sending && (
              <img
                alt="Loading"
                src="https://cdn.pji.nu/rfe/g/loading.e8f390065b1f624a1f5a4a464c96b02b.gif"
              />
            )}
            {!feedback.sending && !feedback.thanks && (
              <Button
                type="submit"
                style={{ width: '100%' }}
                color="primary"
                data-test="FeedbackFormSubmitButton"
              >
                <T domain="feedback">dialog.send-button</T>
              </Button>
            )}
            {feedback.thanks && (
              <S.HelperText bold>
                <T domain="feedback">dialog.thanks-for-feedback</T>
              </S.HelperText>
            )}
          </S.Section>
        </S.Form>
      </S.Inner>
    );
  }
}

FeedbackForm.contextType = AppContext;

FeedbackForm.propTypes = {
  feedback: PropTypes.shape({
    id: PropTypes.number.isRequired,
    open: PropTypes.bool.isRequired,
    sending: PropTypes.bool.isRequired,
    thanks: PropTypes.bool.isRequired,
    error: PropTypes.string,
    email: PropTypes.string,
    tag: PropTypes.string.isRequired,
    group: PropTypes.string.isRequired,
  }).isRequired,
  sendRequest: PropTypes.func.isRequired,
};

export default connect(
  state => ({
    feedback: state.feedback,
    data: state,
  }),
  feedbackActions
)(FeedbackForm);
